export default function (full = false, action) {
    switch(action.type) {
        case "FULLSCREEN": 
            return action.payload
        default:
            return full;
    }
}